import { takeLatest, all, call, put } from "redux-saga/effects"
import { API, graphqlOperation } from "aws-amplify"

import {
  fetchOptionsStart,
  fetchOptionsSuccess,
  fetchOptionsError,
  createOptionError,
  deleteOptionSuccess,
  deleteOptionError,
  updateOptionError,
  sendCalculationSuccess,
} from "./options.actions"
import {
  FETCH_OPTIONS_START,
  CREATE_OPTION_START,
  DELETE_OPTION_START,
  UPDATE_OPTION_START,
  SEND_CALCULATION_START,
} from "./options.types"
import { listCategoryUnits } from "../../graphql/queries"
import {
  createCategoryUnit,
  deleteCategoryUnit,
  updateCategoryUnit,
  createEstimation,
} from "../../graphql/mutations"
import putImageToS3Bucket from "../../utils/putImageToS3Bucket"
import showErrorMessage from "../../utils/showErrorMessage"

export function* fetchOptions() {
  try {
    const res = yield API.graphql({
      ...graphqlOperation(listCategoryUnits),
      variables: { limit: 1000 },
      authMode: "API_KEY",
    })

    yield put(fetchOptionsSuccess(res.data.listCategoryUnits.items))
  } catch ({ errors }) {
    showErrorMessage(errors)
    yield put(fetchOptionsError(errors))
  }
}

export function* createOption({ payload }) {
  try {
    const { image, values } = payload
    const S3Image = yield putImageToS3Bucket(image)

    const input = {
      image: S3Image || {},
      ...values,
    }

    yield API.graphql(graphqlOperation(createCategoryUnit, { input }))
    yield put(fetchOptionsStart())
  } catch ({ errors }) {
    showErrorMessage(errors)
    yield put(createOptionError(errors))
  }
}

export function* deleteOption({ payload }) {
  const input = {
    id: payload.id,
    _version: payload._version,
  }

  try {
    const res = yield API.graphql(
      graphqlOperation(deleteCategoryUnit, { input })
    )

    yield put(deleteOptionSuccess(res.data.deleteCategoryUnit))
    yield put(fetchOptionsStart())
  } catch ({ errors }) {
    showErrorMessage(errors)
    yield put(deleteOptionError(errors))
  }
}

export function* updateOption({ payload }) {
  try {
    const { image, option, values } = payload
    const S3Image = yield putImageToS3Bucket(image)

    const input = {
      id: option.id,
      image: S3Image || option.image,
      _version: option._version,
      ...values,
    }

    yield API.graphql(graphqlOperation(updateCategoryUnit, { input }))

    yield put(fetchOptionsStart())
  } catch ({ errors }) {
    showErrorMessage(errors)
    yield put(updateOptionError(errors))
  }
}

export function* sendCalculation({ payload }) {
  try {
    const { user, platform, categories, cost } = payload

    const input = {
      email: user.email,
      platform: JSON.stringify(platform),
      configs: JSON.stringify(categories),
      cost,
    }

    const { data: estimation } = yield API.graphql({
      ...graphqlOperation(createEstimation),
      variables: { input },
      authMode: "API_KEY",
    })

    yield API.post("appConfiguratorRestApi", "/estimate/send-email", {
      body: {
        ...payload,
        estimationID: estimation.createEstimation.id,
      },
    })

    yield put(sendCalculationSuccess())
  } catch ({ errors }) {
    showErrorMessage(errors)
  }
}

// Options sagas
export function* onFetchOptionsStart() {
  yield takeLatest(FETCH_OPTIONS_START, fetchOptions)
}

// Single option sagas
export function* onCreateOptionStart() {
  yield takeLatest(CREATE_OPTION_START, createOption)
}

export function* onDeleteOptionStart() {
  yield takeLatest(DELETE_OPTION_START, deleteOption)
}

export function* onUpdateOptionStart() {
  yield takeLatest(UPDATE_OPTION_START, updateOption)
}

export function* onSendCalculationStart() {
  yield takeLatest(SEND_CALCULATION_START, sendCalculation)
}

export function* optionsSagas() {
  yield all([
    call(onFetchOptionsStart),
    call(onDeleteOptionStart),
    call(onUpdateOptionStart),
    call(onCreateOptionStart),
    call(onSendCalculationStart),
  ])
}
